import { REFS_FETCH_SUCCESS } from 'constants/actionTypes';
import { initialState } from '../selectors/refs';

export default (state = initialState, action) => {
  switch (action.type) {
    case REFS_FETCH_SUCCESS:
      return { ...state, ...action.payload };

    default:
      return state;
  }
};
